(function($){
  'use strict';

  $(document).ready(function() {

    // Utility function. Causes the callback to only fire after a delay. If the
    // callback is called before the delay it waits. Useful for rapidly firing callbacks
    // like window.resize
    // -------------------------------------------------------------------
    var waitForIdle = function(fn, delay) {
      var timer = null;
      return function () {
        var context = this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    };

    // Utility function. Runs the start callback once and does not allow it to fire again
    // until after a delay. Runs the end callback once after delay has elapsed.
    // Useful for gating behavior around rapidly firing callbacks like window.resize
    // -------------------------------------------------------------------
    var runOnceUntilIdle = function(fnStart, fnEnd, delay) {
      var canRun = true;
      var timer = null;
      return function () {
        var context = this,
            args = arguments;
        if (canRun) {
          fnStart.apply(context, args);
          canRun = false;
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
          canRun = true;
          var context = this,
              args = arguments;
          fnEnd.apply(context, args);
        }, delay);
      };
    };

    // Example code:

    // $(window).resize(runOnceUntilIdle(function() {
    //   console.log('Start');
    //   },
    //   function() {
    //     console.log('End');
    //   },
    //   200
    // ));


    // Get the viewport width & height right away and use through out document.
    // -------------------------------------------------------------------
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();
    $(window).resize(waitForIdle(function() {
      viewportWidth = $(window).width();
      viewportHeight = $(window).height();
    }, 200));

    // end viewport resizing



    // Menu disable transition on resize
    var $primary_menu = $('.menu-main-menu-container ul#primary-menu');

    $(window).resize(runOnceUntilIdle(
      function() {
        $primary_menu.addClass('notrans');
      },
      function() {
        $primary_menu.removeClass('notrans');
      },
      200
    ));


    // Mobile menu
    // -----------------------

    // Mobile menu icon
    $('.mobile-icon').click(function() {

      if ($('.mobile-icon').hasClass('mobile-menu-open')) {
        $('body, .mobile-icon').removeClass('mobile-menu-open');
      } else {
        $('body, .mobile-icon').addClass('mobile-menu-open');
      }
    });

    // Setup initial vars.
    var menuHasChildren = 'li.menu-item-has-children';
    var menuHasChildrenAndContainer = '.menu-main-menu-container ul#primary-menu ' + menuHasChildren;


    // Add expand button
    $('<i class="fa fa-chevron-down"></i><i class="fa fa-chevron-up"></i>').prependTo(menuHasChildrenAndContainer + ' > a');

    // Add class to current menu item
    var setOpenMenuMoblie = function() {
      if ( viewportWidth < 981 ) {
        $(menuHasChildrenAndContainer + '.current-menu-item').addClass('open-submenu');
        $(menuHasChildrenAndContainer + '.current-page-ancestor').addClass('open-submenu');
      } else {
        $(menuHasChildrenAndContainer + '.current-menu-item').removeClass('open-submenu');
        $(menuHasChildrenAndContainer + '.current-page-ancestor').removeClass('open-submenu');
      }
    };
    setOpenMenuMoblie();
    $(window).resize(waitForIdle(function() {
      setOpenMenuMoblie();
    }, 200));

    // Add click funtion to main menu.
    $(menuHasChildrenAndContainer + ' > a').click(function() {

      if ($(this).parent(menuHasChildren).hasClass('open-submenu')) {
        $(this).parent(menuHasChildren).removeClass('open-submenu');
      } else {
        $(menuHasChildren).removeClass('open-submenu');
        $(this).parent(menuHasChildren).addClass('open-submenu');
      }

      return false;
    });

    // Close drop-down on outside click
    $(document).click(function(e) {
      if ( viewportWidth > 980 ) {
        if (($(menuHasChildrenAndContainer).hasClass('open-submenu')) && ($(e.target).closest(menuHasChildrenAndContainer).length === 0)) {
          $(menuHasChildrenAndContainer).removeClass('open-submenu');
        }
      }
    });


    // Icons
    // -----------------------


    // ! Back to top
    //   scroll arrow.
    // ---------------------------------------

    // var longPages = [
    //   'body.page-id-25'
    // ];
    // $(longPages.join(',')).find('.content-container').prepend('<span class="back-top"><i class="fa fa-arrow-up"></i></span>');

    // if ( $(longPages.join(',')).length ) {

    //   $('.back-top').click(function() {
    //     $('html, body').animate({
    //         scrollTop: 0
    //     }, 'slow');
    //   });

    //   $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 50) {
    //       $('.back-top').addClass('scrolling');
    //     } else {
    //       $('.back-top').removeClass('scrolling');
    //     }
    //   });
    // }


  });

})(this.jQuery);
